/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { Clock3 } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';
const NS = '/bff/v1/j10-s04-solicitante-acompanhar-solicitacao';
export function AcompanharSolicitacaoPage() {
  const [e, setE] = useState<any>();
  const [ocupado, setO] = useState(false);
  async function call(path: string, corpo?: unknown) {
    setO(true);
    try {
      const r = await chamarApi<any>(NS + path, {
        metodo: path === '/state' ? 'GET' : 'POST',
        corpo,
      });
      setE(r.state);
    } finally {
      setO(false);
    }
  }
  useEffect(() => {
    void call('/state');
  }, []);
  if (!e) return <main role="status">Carregando andamento…</main>;
  return (
    <main className="w-full min-w-0 space-y-5 overflow-x-hidden">
      <h1 className="text-3xl font-semibold">
        <Clock3 className="mr-2 inline" />
        {e.titulo}
      </h1>
      <p>{e.descricao}</p>
      {e.alertas.map((a: any) => (
        <p role="alert" key={a.codigo}>
          {a.mensagem} <code>{a.codigo}</code>
        </p>
      ))}
      {e.vazio && <p>Nenhum pedido encontrado.</p>}
      {e.pedidos.map((p: any) => (
        <article className="space-y-3 rounded-md border p-4" key={p.id}>
          <h2 className="font-semibold">
            {p.protocolo} · {p.resultado_final ?? p.status}
          </h2>
          <p>
            Fila {p.fila} · prazo {new Date(p.prazo_decisao_em).toLocaleString('pt-BR')}
          </p>
          <p>Registro oficial: {p.observacao_oficial}</p>
          <ol className="space-y-1">
            {p.linha_tempo.map((x: any) => (
              <li key={x.id}>
                {new Date(x.ocorrido_em).toLocaleString('pt-BR')} · {x.tipo} ·{' '}
                {x.motivo_codigo ?? x.motivo}
              </li>
            ))}
          </ol>
          {p.notificacoes.map((n: any) => (
            <aside key={n.id}>
              <strong>{n.titulo}</strong>
              <p>
                {n.mensagem_minimizada} Referência {n.referencia_protocolo}.
              </p>
            </aside>
          ))}
          {!p.encerramento_id && !p.decisao && (
            <Button
              disabled={ocupado}
              variant="outline"
              onClick={() =>
                void call('/verbs/cancelar_pedido', {
                  solicitacaoId: p.id,
                  chaveIdempotencia: crypto.randomUUID(),
                })
              }
            >
              Cancelar pedido
            </Button>
          )}
          <code className="break-all">{p.id}</code>
        </article>
      ))}
      {e.resultado && <p role="status">Operação persistida: {JSON.stringify(e.resultado)}</p>}
    </main>
  );
}
